import { BsChevronDown, BsChevronUp, BsChevronExpand } from "react-icons/bs"
import { HeaderGroup } from "react-table"

interface IProps {
    column:any
}
export function ColumnSort (props: IProps) {
return <span {...props.column.getSortByToggleProps()}  style={{margin:'10px 3px 0px 3px'}}>{props.column.isSorted ?(props.column.isSortedDesc ? <BsChevronDown/> : <BsChevronUp/>): <BsChevronExpand/>}</span>

}